export default __webpack_public_path__ + "static/948-f9c2587f5a1665ab04c58a1a2351da17.gif";